import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

// Concurrent /api/csrf responses on a session without a token each mint a
// different one, and only the last session cookie survives, so instances
// mounted together must share a single request.
let pendingFetch = null

const fetchCsrfToken = () => {
  pendingFetch ??= fetch('/api/csrf', { credentials: 'same-origin' })
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => data?.csrfToken)
    .catch(() => undefined)
    .finally(() => {
      pendingFetch = null
    })
  return pendingFetch
}

// Non-cached SSR provides the token via Redux props; cached pages fill in from
// the meta tag, and edge-cached pages omit even that, so fetch from /api/csrf.
const AuthToken = () => {
  const reduxToken = useSelector(({ auth }) => auth.csrfToken) || ''
  const [token, setToken] = useState(reduxToken)

  useEffect(() => {
    if (token) return undefined
    const meta = document.querySelector('meta[name=csrf-token]')
    const value = meta && meta.getAttribute('content')
    if (value) {
      setToken(value)
      return undefined
    }
    let cancelled = false
    fetchCsrfToken().then((csrfToken) => {
      if (!cancelled && csrfToken) setToken(csrfToken)
    })
    return () => {
      cancelled = true
    }
  }, [])

  return <input type="hidden" name="authenticity_token" value={token} />
}

export default AuthToken
